
export class PolicyConstants{

    public static CUSTOMER_DATA_POLICIES = "CustomerDataPolicies";
    public static OPERATOR_DATA_POLICIES = "OperatorDataPolicies";
    public static SALES_REPORT_POLICIES = "SalesReportPolicies";
    public static SEPA_POLICIES = "SepaPolicies";
    public static SYSTEM_ADMINISTRATION_POLICIES = "SystemUserAdministratePolicies";
    public static USER_DATA_POLICIES = "UserDataPolicies";
    public static ACCOUNT_DATA_POLICIES = "AccountDataPolicies";
}
